import router from '@/router'
import store from '@/store'
import LocalStorage from '@/utils/LocalStorage'
import config from '../configs/config'
const RouterInterceptor = {
  install () {
    router.beforeEach(async (to, from, next) => {
      // Close all modal when change router
      store.dispatch('closeAllModal')
      // Check page is required authenticated
      document.title = 'Red River Gate | ' + to.meta.title || 'Home'
      if (config.IS_DEVELOPMENT) {
        next()
      } else {
        if (to.matched.some(record => record.meta.requiresAuth)) {
          const tokenObj = LocalStorage.getToken()
          // If token is empty, redirect to login page
          if (tokenObj) {
            next()
          } else {
            router.push({ name: 'landing' })
          }
        } else { // Page is not required authenticated
          next()
        }
      }
    })
  }
}
export default RouterInterceptor
